<template>
    <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>sports_soccer</md-icon>
      </div>
      <h4 class="title">
        <strong>{{game.local.name}} vs {{game.visitor.name}}</strong> | <small>{{dateFormat()}}</small> 
      </h4>
    </md-card-header>
    <md-card-content>
      <md-datepicker md-immediately v-model="datePublish">
        <label>{{$t('games.detail.datePublish')}}</label>
      </md-datepicker>
      <md-button class="md-block" :disabled="datePublish == ''" @click="publish()">Publicar</md-button>
    </md-card-content>
  </md-card>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    game: Object,
    gameId: Number
  },
  data() {
    return {
      datePublish: ''
    }
  },
  methods: {
    dateFormat() {
      return moment(this.game.scheduledMatchDate).format('DD/MM/YYYY HH:mm')
    },
    async publish() {
      console.log(this.datePublish)
      const request = await this.$store.dispatch('publish', {
        publishDate: moment(this.datePublish, "DD/MM/YYYY").format('YYYY-MM-DD'),
        gameId: this.gameId
      })
      if (request != undefined) {
        this.$store.dispatch('getGame', { gameId: this.gameId })
        this.$notify({
          message: this.$t(`notifications.game.publish`),
          icon: 'add_alert',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: 'success'
        })
      } else {
        this.$store.dispatch("openModalError")
      }
    }
  }
}
</script>

<style>

</style>